import React from 'react';
import { useForm, Controller } from 'react-hook-form';
import { Input } from '../common/Input';
import { Button } from '../common/Button';
import { Card } from '../common/Card';
import { AdjustConfig } from '../../types/game.types';

interface AdjustConfigFormProps {
  config?: AdjustConfig;
  onSubmit: (config: AdjustConfig) => Promise<void>;
  isLoading?: boolean;
}

export const AdjustConfigForm: React.FC<AdjustConfigFormProps> = ({ 
  config, 
  onSubmit, 
  isLoading 
}) => {
  const { control, handleSubmit, formState: { errors } } = useForm<AdjustConfig>({
    defaultValues: config || {
      appTokens: {
        default: '',
        oppo: '',
        vivo: '',
      },
      s2sAuthToken: '',
      subscriptionEvents: {
        created: '',
        renewed: '',
        cancelled: '',
      },
      productEvents: {},
    },
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
      <Card title="App Tokens">
        <div className="space-y-4">
          <Controller
            name="appTokens.oppo"
            control={control}
            render={({ field }) => (
              <Input
                {...field}
                label="OPPO App Token"
                placeholder="oppo_adjust_app_token"
              />
            )}
          />
          <Controller
            name="appTokens.vivo"
            control={control}
            render={({ field }) => (
              <Input
                {...field}
                label="VIVO App Token"
                placeholder="vivo_adjust_app_token"
              />
            )}
          />
        </div>
      </Card>

      <Card title="Authentication">
        <Controller
          name="s2sAuthToken"
          control={control}
          rules={{ required: 'S2S auth token is required' }}
          render={({ field }) => (
            <Input
              {...field}
              label="S2S Auth Token"
              placeholder="your_s2s_auth_token"
              type="password"
              error={errors.s2sAuthToken?.message}
              required
            />
          )}
        />
      </Card>



      <div className="flex justify-end space-x-3">
        <Button type="button" variant="secondary">
          Cancel
        </Button>
        <Button type="submit" isLoading={isLoading}>
          Save Configuration
        </Button>
      </div>
    </form>
  );
};